<template>
  <v-dialog
      v-model='showModal'
      fullscreen
      :scrim='false'
      transition='dialog-bottom-transition'
      width="100vw"
  >
    <v-card tile>
      <v-toolbar
          tile
          dark
          color='primary'
      >
        <v-btn
            icon
            dark
            @click='dropModal'
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Редактирование экземпляра</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-form
          id="exhibitCreationForm"
          style="width: 100vw"
          v-model="valid"
          lazy-validation
          ref="form"
      >

      <div>
        <v-row no-gutters>
          <v-col sm="4">
            <v-card height="100%" tile elevation="3" class="pa-5 pt-0 mt-2">
              <v-text-field
                  autocomplete="off"
                  :rules="nameRules"
                  v-model="exhibitObject.barcode"
                  required
                  name="barcode"
                  class="rounded-0"
                  label="штрихкод"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.family"
                  name="family"
                  class="rounded-0"
                  label="семейство"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.genus"
                  name="genus"
                  class="rounded-0"
                  label="род"
                  @blur="getIndexByGenus"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.species"
                  name="species"
                  class="rounded-0"
                  label="вид"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.labelName"
                  v-if="!isLichen"
                  name="labelName"
                  class="rounded-0"
                  label="название на этикетке"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.taxonomy"
                  v-if="!isLichen"
                  name="taxonomy"
                  class="rounded-0"
                  label="таксономия по Catalogue of Life"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.synonym"
                  v-if="!isLichen"
                  name="synonym"
                  class="rounded-0"
                  label="синонимы"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.taxonomy"
                  v-if="isLichen"
                  name="taxonomy"
                  class="rounded-0"
                  label="принятый таксон"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.ecologicalCharacteristics"
                  v-if="isLichen"
                  name="eco"
                  class="rounded-0"
                  label="экологическая характеристика места обитания"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.powotaxonomy"
                  v-if="!isLichen"
                  name="powotaxonomy"
                  class="rounded-0"
                  label="таксономия по POWO"
              />
            </v-card>
          </v-col>

          <v-col sm="4">
            <v-card height="100%" tile elevation="3" class="pa-5 pt-0 mt-2">
              <v-text-field
                  autocomplete="off"
                  v-if="!isLichen"
                  v-model="exhibitObject.russianName"
                  name="russianName"
                  class="rounded-0"
                  label="русское название"
              />
              <v-text-field
                  autocomplete="off"
                  v-if="!isLichen"
                  v-model="exhibitObject.labelsCount"
                  name="labelsAmount"
                  class="rounded-0"
                  label="количество этикеток"
              />
              <date-period-component @emit-method-name="updateCollectionDate"
                                     label-text="дата сбора"
                                     :initial-date="exhibitObject.collectionDate"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.collectors"
                  name="collectors"
                  class="rounded-0"
                  label="коллекторы"
              />
              <date-period-component @emit-method-name="updateDeterminationDate"
                                     label-text="дата определения"
                                     :initial-date="exhibitObject.determinationDate"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.determinatedBy"
                  name="determinedBy"
                  class="rounded-0"
                  label="кем детерминировано"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.natureConservationStatus"
                  name="conservationStatus"
                  class="rounded-0"
                  label="природоохранный статус"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.numberOfHerbariumSheets"
                  name="numberOfHerbariumSheets"
                  class="rounded-0"
                  label="количество гербарных листов"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.note"
                  v-if="isLichen"
                  name="note"
                  class="rounded-0"
                  label="примечание"
              />
            </v-card>
          </v-col>
          <v-col sm="4">
            <v-card height="100%" tile elevation="3" class="pa-5 mt-2">
              <v-textarea
                  autocomplete="off"
                  v-model="exhibitObject.labelText"
                  name="labelText"
                  dense
                  outlined
                  class="rounded-0"
                  label="текст этикетки"
                  no-resize
                  rows="3"
              />
              <v-text-field
                  readonly
                  autocomplete="off" name="index"
                  v-model="exhibitObject.index"
                  class="rounded-0 mt-0"
                  label="индекс рода"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.submittedBy"
                  name="insertedBy"
                  class="rounded-0"
                  label="образец внес"
              />
              <v-text-field
                  autocomplete="off"
                  name="gatheringPlaceDistrict"
                  v-model="exhibitObject.gatheringPlaceDistrict"
                  class="rounded-0"
                  label="район сбора"
              />
              <v-text-field
                  autocomplete="off"
                  name="gatheringPlaceRegion"
                  v-model="exhibitObject.gatheringPlaceRegion"
                  class="rounded-0"
                  label="область/республика сбора"
              />
              <v-text-field
                  autocomplete="off"
                  name="gatheringPlaceCountry"
                  v-model="exhibitObject.gatheringPlaceCountry"
                  class="rounded-0"
                  label="страна сбора"
              />
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mt-5" no-gutters>
          <v-col sm="12">
            <v-card height="100%" tile elevation="3" class="pa-5 pt-2">
              <v-row no-gutters>
              <h4 class="mb-0 align-self-center">GPS-координаты</h4>
              <v-menu   offset-x
                        right
                        open-on-hover
                        :close-on-content-click="false"
              >
                <template #activator="{ on, attrs }">
                  <v-btn plain class="ms-2" icon v-on="on">
                    <v-icon large color="red"> mdi-alert-outline </v-icon>
                  </v-btn>
                </template>
                <v-card tile class="ma-0 pa-5">
                  <v-card-title class="pa-0 pb-3">Рекомендуемый формат координат:</v-card-title>
                  <p class="font-weight-bold">Градусы, минуты и секунды + доп. буквы</p>
                  <p class="font-weight-bold">Примеры:</p>
                  <p class="font-weight-bold">Широта: 53°30'14.13''N</p>
                  <p class="font-weight-bold">Долгота: 48°52'56.29''E</p>
                  <p class="color-primary">Корректное отображение координат в других форматах не гарантировано</p>
                </v-card>
              </v-menu>
              </v-row>
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.gps.latitude"
                  name="latitudeGPS"
                  class="rounded-0 mt-0"
                  label="широта"
              />
              <v-text-field
                  autocomplete="off"
                  v-model="exhibitObject.gps.longitude"
                  name="longitudeGPS"
                  class="rounded-0"
                  label="долгота"
              />
            </v-card>
          </v-col>
        </v-row>
      </div>
        <v-row class="mr-0 mt-0">
          <v-col v-if="exhibitObject.plantType === 'HIGHER_PLANT'">
            <v-card elevation="0">
              <v-card-title>Добавить новые фото этикеток</v-card-title>
              <UploadScans :rules="[true]" :label-text="'Прикрепите фото этикетки нажав сюда'" @pass="addLabelPhoto"/>
            </v-card>

            <v-card class="mt-3">
              <v-card-title>Уже добавленные фото этикеток</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col sm="3" v-for="(photo, index) in this.exhibitObject.originalLabelPhotos">
                    <v-img
                        width="100%"
                        :src="labelCompressedPhotoPath + `/${photo.compressedPhotoPath}`"
                    >
                      <v-btn @click="deleteLabelPhoto(index)" class="float-right" icon color="red">
                        <v-tooltip color="red" class="rounded-0" right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="red"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                          <span>удалить</span>
                        </v-tooltip>
                      </v-btn>

                    </v-img>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-card elevation="0">
              <v-card-title>Добавить новые сканы</v-card-title>
              <UploadScans :rules="[true]" :label-text="'Прикрепите сканы нажав сюда'" @pass="logData"/>
            </v-card>

            <v-card class="mt-3">
              <v-card-title>Уже добавленные сканы экземпляра</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col sm="3" v-for="(photo, index) in this.exhibitObject.photos">
                    <v-img
                        width="100%"
                        :src="exhibitCompressedPhotoPath + `/${photo.compressedPhotoPath}`"
                    >
                      <v-btn @click="deleteScan(index)" class="float-right" icon color="red">
                        <v-tooltip color="red" class="rounded-0" right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="red"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                          <span>удалить</span>
                        </v-tooltip>
                      </v-btn>

                    </v-img>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mr-0">
          <v-spacer/>
          <v-col cols="auto">
            <v-card tile class="d-inline-block" elevation="10">
              <v-btn
                  tile
                  text
                  color="blue"
                  @click="updatePlant"
              >Сохранить изменения
              </v-btn>
              <v-btn
                  tile
                  text
                  color="red"
                  @click="dropModal"
              >Отменить изменения
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <LoadingModal :is-loading="isLoading"/>
  </v-dialog>
</template>

<script>
import UploadScans from "@/components/ExhibitCreationPageComponents/UploadScans";
import LoadingModal from "@/components/UI/LoadingModal";
import {addExhibitPhotos, updateExhibit, deleteExhibitPhoto, addExhibitLabelPhotos, deleteExhibitLabelPhotos} from "@/services/exhibitAPI";
import {findGenusIndexByGenus} from "@/services/genusIndexAPI"
import ToastService from "@/services/toastService";
import DatePeriodComponent from "@/components/ExhibitCreationPageComponents/DatePeriodComponent.vue";
import {labelCompressedPhotoPath, exhibitCompressedPhotoPath} from "@/helpers/siteURL";

export default {
  name: "ExhibitUpdate",
  components: {DatePeriodComponent, UploadScans, LoadingModal},


  data() {
    return {
      isLoading: false,
      isLichen: false,
      valid: false,
      nameRules: [
        v => !!v || 'Поле не может быть пустым',
      ],

      exhibitObject: {
        gps: {
          latitude: '',
          longitude: ''
        }
      },

      scans: [],
      labelPhotos: [],
      labelCompressedPhotoPath: labelCompressedPhotoPath,
      exhibitCompressedPhotoPath: exhibitCompressedPhotoPath,

    }
  },

  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    plant: {
      type: Object,
      required: true,
    }
  },

  methods: {
    dropModal() {
      this.$vuetify.goTo(0)
      this.$emit('drop-modal')
      this.refresh()
    },

    async deleteScan(index) {
      try {
        this.exhibitObject.photos = this.exhibitObject.photos.filter((item, i) => {
          if (i !== index) return item
        })
        await deleteExhibitPhoto(this.$route.params.id, index)
      } catch (e) {
        console.log(e);
      }
    },

    async deleteLabelPhoto(index) {
      try {
        this.exhibitObject.originalLabelPhotos = this.exhibitObject.originalLabelPhotos.filter((item, i) => {
          if (i !== index) return item
        })
        await deleteExhibitLabelPhotos(this.$route.params.id, index)
      } catch (e) {
        console.log(e);
      }
    },

    async updatePlant() {
      this.isLoading = true
      if (this.$refs.form.validate()) {
        try {
          await updateExhibit(this.$route.params.id, this.exhibitObject)
          try {
            for (const scan of this.scans) {
              await addExhibitPhotos(scan, this.$route.params.id).then(data => console.log(data));
            }
            for (const photo of this.labelPhotos) {
              await addExhibitLabelPhotos(photo, this.$route.params.id).then(data => console.log(data));
            }
          } catch (e) {
            console.log(e);
          }

          await this.$router.go()
        } catch (e) {
          console.log(e);
        } finally {
          this.isLoading = false
        }
      }
    },

    logData(scans) {
      this.scans = scans;
      console.log(this.scans);
    },

    addLabelPhoto(photos) {
      this.labelPhotos = photos;
      console.log(this.labelPhotos);
    },

    refresh() {
      this.exhibitObject = {
        barcode: this.plant.barcode,
        family: this.plant.family,
        genus: this.plant.genus,
        index: this.plant.index,
        species: this.plant.species,
        labelName: this.plant.labelName,
        taxonomy: this.plant.taxonomy,
        synonym: this.plant.synonym,
        russianName: this.plant.russianName,
        labelText: this.plant.labelText,
        originalLabelPhotos: this.plant.originalLabelPhotos,
        labelsCount: this.plant.labelsCount,
        gps: {
          latitude: this.plant.gps.latitude,
          longitude: this.plant.gps.longitude,
        },
        collectionDate: {
          startDate: this.plant.collectionDate.startDate,
          endDate: this.plant.collectionDate.endDate,
        },
        photos: this.plant.photos,
        collectors: this.plant.collectors,
        determinationDate: {
          startDate: this.plant.determinationDate.startDate,
          endDate: this.plant.determinationDate.endDate,
        },
        determinatedBy: this.plant.determinatedBy,
        natureConservationStatus: this.plant.natureConservationStatus,
        numberOfHerbariumSheets: this.plant.numberOfHerbariumSheets,
        gatheringPlaceCountry: this.plant.gatheringPlaceCountry,
        gatheringPlaceRegion: this.plant.gatheringPlaceRegion,
        gatheringPlaceDistrict: this.plant.gatheringPlaceDistrict,
        addedDate: this.plant.addedDate,
        submittedBy: this.plant.submittedBy,
        ecologicalCharacteristics: this.plant.ecologicalCharacteristics,
        note: this.plant.note,
        plantType: this.plant.plantType,
        powotaxonomy: this.plant.powotaxonomy,
      }
    },

    async getIndexByGenus() {
      if (this.exhibitObject.genus) {
        this.isLoading = true
        await findGenusIndexByGenus(this.exhibitObject.genus)
            .then((data) => {
              this.exhibitObject.index = data.index;
            })
            .catch((e) => {
              if (e.response.status === 404) {
                ToastService.toastError("Ошибка сервера")
              }
            })
            .finally(() => {
              this.isLoading = false
            })
      }
    },

    updateCollectionDate(startDateObj, endDateObj) {
      this.exhibitObject.collectionDate.startDate = startDateObj;
      this.exhibitObject.collectionDate.endDate = endDateObj;
    },

    updateDeterminationDate(startDateObj, endDateObj) {
      this.exhibitObject.determinationDate.startDate = startDateObj;
      this.exhibitObject.determinationDate.endDate = endDateObj;
    }
  },

  created() {
    this.$props.plant.plantType === "HIGHER_PLANT" ? this.isLichen = false : this.isLichen = true
  },

  mounted() {
    this.refresh()
  }
}
</script>

<style scoped>

</style>